import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authApi } from '../api';
import HrnbForm from './controls/HrnbForm';
import HrnbButton from './controls/HrnbButton';
import HrnbFormControl from './controls/HrnbFormControl';
import HrnbAlert from './controls/HrnbAlert';
import HrnbLoader from './controls/HrnbLoader';

const ConfirmEmail = () => {
    const { confirmationToken } = useParams();
    const [message, setMessage] = useState('');
    const [messageVariant, setMessageVariant] = useState('success');
    const [loading, setLoading] = useState(false);
    const [inputToken, setInputToken] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (confirmationToken) {
            const confirmEmail = async () => {
                setLoading(true);
                try {
                    await authApi.confirmEmail(confirmationToken);
                    setMessage('Ваш email успешно подтверждён!');
                    setMessageVariant('success');
                    setTimeout(() => navigate('/login'), 2000);
                } catch (error) {
                    setMessage(`Ошибка: ${error.response?.data?.message || error.message}`);
                    setMessageVariant('danger');
                } finally {
                    setLoading(false);
                }
            };
            confirmEmail();
        }
    }, [confirmationToken, navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage('');
        try {
            await authApi.confirmEmail(inputToken);
            setMessage('Ваш email успешно подтверждён!');
            setMessageVariant('success');
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            setMessage(`Ошибка: ${error.response?.data?.message || error.message}`);
            setMessageVariant('danger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="confirm-email-container" style={{ maxWidth: 400, margin: '40px auto', padding: 24 }}>
            <h2 style={{ marginBottom: 20, color: '#e0e0e0' }}>Подтверждение email</h2>
            {confirmationToken ? (
                <div>
                    {loading ? (
                        <HrnbLoader text="Идёт подтверждение..." />
                    ) : (
                        message && <HrnbAlert type={messageVariant}>{message}</HrnbAlert>
                    )}
                </div>
            ) : (
                <HrnbForm onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', marginBottom: 6, color: '#b0b8c4' }}>Введите токен подтверждения:</label>
                        <HrnbFormControl
                            type="text"
                            placeholder="Токен подтверждения"
                            value={inputToken}
                            onChange={(e) => setInputToken(e.target.value)}
                            required
                        />
                    </div>
                    <HrnbButton variant="primary" type="submit" disabled={loading}>
                        {loading ? 'Подтверждение...' : 'Подтвердить email'}
                    </HrnbButton>
                    {message && (
                        <div style={{ marginTop: 16 }}>
                            <HrnbAlert type={messageVariant}>{message}</HrnbAlert>
                        </div>
                    )}
                </HrnbForm>
            )}
        </div>
    );
};

export default ConfirmEmail;